var map = {
	"./afb-color.svg": 1718,
	"./afb.svg": 1719,
	"./alb-color.svg": 1720,
	"./alb.svg": 1721,
	"./amb-color.svg": 1722,
	"./amb.svg": 1723,
	"./bbbaidja-color.svg": 1724,
	"./bbbaidjaxxx-color.svg": 1725,
	"./bdinidjaxxx-color.svg": 1726,
	"./bimb-color.svg": 1727,
	"./bimb.svg": 1728,
	"./bkr-color.svg": 1729,
	"./bkr.svg": 1730,
	"./bmriidja-color.svg": 1731,
	"./bniaidja-color.svg": 1732,
	"./bninidja-color.svg": 1733,
	"./bninidjaxxx-color.svg": 1734,
	"./bpay-color.svg": 1735,
	"./brinidja002-color.svg": 1736,
	"./bsmdidjaxxx-color.svg": 1737,
	"./bsn-color.svg": 1738,
	"./bsn.svg": 1739,
	"./btanidjaxxx-color.svg": 1740,
	"./cenaidja-color.svg": 1741,
	"./cenaidjaxxx-color.svg": 1742,
	"./cimb-color.svg": 1743,
	"./cimb.svg": 1744,
	"./citi-color.svg": 1745,
	"./citi.svg": 1746,
	"./default-bank-icon-color.png": 1747,
	"./default-bank-icon.png": 1748,
	"./gxbank-color.svg": 1749,
	"./hlb-color.svg": 1750,
	"./hlb.svg": 1751,
	"./hsbc-color.svg": 1752,
	"./hsbc.svg": 1753,
	"./ibbkidjaxxx-color.svg": 1754,
	"./kwh-color.svg": 1755,
	"./kwh.svg": 1756,
	"./mbb-color.svg": 1757,
	"./mbb.svg": 1758,
	"./nispidjaxxx-color.svg": 1759,
	"./ocbc-color.svg": 1760,
	"./ocbc.svg": 1761,
	"./pbb-color.svg": 1762,
	"./pbb.svg": 1763,
	"./pinbidja-color.svg": 1764,
	"./rhb-b.svg": 1765,
	"./rhb-color-b.svg": 1766,
	"./rhb-color.svg": 1767,
	"./rhb.svg": 1768,
	"./scb-color.svg": 1769,
	"./scb.svg": 1770,
	"./tng-color.svg": 1771,
	"./uob-color.svg": 1772,
	"./uob.svg": 1773
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 127;